import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

const useKeyboard = () => {
  return { hideKeyboard: Capacitor.getPlatform() !== 'web' ? Keyboard.hide : undefined };
};

export default useKeyboard;
